import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const AvailabilitySubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./AvailabilitySubForm"))
);
